import { Component, OnInit, Input } from '@angular/core';

@Component({
    selector: 'sabis-ngx-arrow-icon',
    template: `
    <svg [attr.class]="scClass" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"	 width="15px" height="9px" viewBox="381.834 96.701 14 7.383" enable-background="new 381.834 96.701 14 7.383"            xml:space="preserve">       <path  d="M395.654,96.768c-0.232-0.232-0.636-0.232-0.868,0l-5.953,5.948l-5.951-5.948            c-0.232-0.232-0.637-0.231-0.867-0.001c-0.116,0.115-0.181,0.27-0.181,0.435c0,0.164,0.064,0.318,0.18,0.435l6.386,6.383            c0.116,0.115,0.27,0.18,0.434,0.18s0.317-0.064,0.434-0.18l6.388-6.383c0.116-0.117,0.181-0.271,0.18-0.436            C395.834,97.036,395.77,96.882,395.654,96.768z"/>        </svg>
`
})
export class SabisArrowIconComponent implements OnInit {
  @Input() scClass: string = '';

  constructor() { }

  ngOnInit() {
  }
}
